module.exports = "<div class=gmc-iframe-modal><gmc-panel header=\"Payment Process\" close-btn=true on-close=$ctrl.closeModal(false)><div class=iframe-wrapper ng-if=$ctrl.isIframeVisible><iframe id=paymentIframe ng-src={{$ctrl.iframeUrl}} frameborder=0 gmc-onload=$ctrl.onIframeLoaded()></iframe></div></gmc-panel></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/payment-iframe-modal/payment-iframe-modal.component.html
// module id = 553
// module chunks = 31